var chunkMapping = {
	"360": [
		28359
	],
	"792": [
		87431
	],
	"865": [
		98944,
		44726
	],
	"3116": [
		78259
	],
	"3322": [
		7732
	],
	"3455": [
		14885,
		19476,
		20871,
		35702,
		45633,
		65683,
		93067,
		93432
	],
	"5481": [
		15397,
		16428,
		32678,
		39465,
		44745,
		48835,
		50712,
		57239,
		58487,
		70939,
		73514,
		74463,
		84932,
		85497,
		85583,
		86377,
		90448,
		93740
	],
	"6696": [
		33061,
		34859,
		45254,
		70550
	],
	"6884": [
		87209
	],
	"6925": [
		1022
	],
	"6981": [
		2367
	],
	"8937": [
		18937
	],
	"9944": [
		63972
	]
};
var idToExternalAndNameMapping = {
	"1022": [
		"default",
		"./OrganizationActivityView",
		20474
	],
	"2367": [
		"default",
		"./DigitsInput",
		20474
	],
	"7732": [
		"default",
		"./ExportImportContainerView",
		20474
	],
	"14885": [
		"default",
		"./Table",
		20474
	],
	"15397": [
		"default",
		"./Card",
		20474
	],
	"16428": [
		"default",
		"./EditIcon",
		20474
	],
	"18937": [
		"default",
		"./LocalizedNumberFormatter",
		20474
	],
	"19476": [
		"default",
		"./IconButton",
		20474
	],
	"20871": [
		"default",
		"./Heading",
		20474
	],
	"28359": [
		"default",
		"./organizationSwitcher",
		20474
	],
	"32678": [
		"default",
		"./BackButton",
		20474
	],
	"33061": [
		"default",
		"./EnergyDemandView",
		20474
	],
	"34859": [
		"default",
		"./PostalCodeDemographics",
		20474
	],
	"35702": [
		"default",
		"./FileSearchIcon",
		20474
	],
	"39465": [
		"default",
		"./Input",
		20474
	],
	"44726": [
		"default",
		"./LocalizedNumberFormatterMethod",
		20474
	],
	"44745": [
		"default",
		"./BottomBar",
		20474
	],
	"45254": [
		"default",
		"./EstimatedValueChart",
		20474
	],
	"45633": [
		"default",
		"./TotpUser",
		20474
	],
	"48835": [
		"default",
		"./Accordion",
		20474
	],
	"50712": [
		"default",
		"./Tooltip",
		20474
	],
	"57239": [
		"default",
		"./UpdateIcon",
		20474
	],
	"58487": [
		"default",
		"./DocumentationButton",
		20474
	],
	"63972": [
		"default",
		"./recalculate",
		20474
	],
	"65683": [
		"default",
		"./EditableSelect",
		20474
	],
	"70550": [
		"default",
		"./EsgViewCollateral",
		20474
	],
	"70939": [
		"default",
		"./Button",
		20474
	],
	"73514": [
		"default",
		"./TitleBar",
		20474
	],
	"74463": [
		"default",
		"./Select",
		20474
	],
	"78259": [
		"default",
		"./settingsView",
		20474
	],
	"84932": [
		"default",
		"./DownloadIcon",
		20474
	],
	"85497": [
		"default",
		"./NotificationBell",
		20474
	],
	"85583": [
		"default",
		"./Tabs",
		20474
	],
	"86377": [
		"default",
		"./Textarea",
		20474
	],
	"87209": [
		"default",
		"./EsgPortfolioView",
		20474
	],
	"87431": [
		"default",
		"./SkenariosView",
		20474
	],
	"90448": [
		"default",
		"./AccountButton",
		20474
	],
	"93067": [
		"default",
		"./ValuationIcon",
		20474
	],
	"93432": [
		"default",
		"./PasswordChange",
		20474
	],
	"93740": [
		"default",
		"./Breadcrumb",
		20474
	],
	"98944": [
		"default",
		"./LocalizedDateFormatter",
		20474
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}